import * as types from './actionTypes';
import apiAction from './apiAction';

const config = window.weftConfig;


export function hmacEncodeProduct(product) {
	return apiAction(config.webApiSwaggerDoc)(
    'HMAC_ENCODE',
    api => api.hmac.post2,
    { product: product },
  );
}


function updateCartAction(itemCount) {
  return {
    type: types.UPDATE_CART,
    itemCount: itemCount,
  };
}

export function updateCart(itemCount=null) {
  return (dispatch, getState) => {
    dispatch(updateCartAction(itemCount));
  };
}


function applyCouponCodeAction(code) {
  return {
    type: types.APPLY_COUPON_CODE,
    code: code,
  };
}

export function applyCouponCode(code) {
  return (dispatch, getState) => {
    dispatch(applyCouponCodeAction(code));

    // Build cart request into GET query string
    var cartEndpoint = `https://${config.FOXYCART_STORE_URL}/cart?coupon=${code}`;

    if (window.FC) {
      // Use native FoxyCart script to add product to cart
      window.FC.client.request(cartEndpoint);
    } else {
      // Fall back to fetch if Foxycart script isn't loaded
      console.log("Warning: FoxyCart script not loaded!");
      cartEndpoint += "&output=json&callback=?"
      return fetch(cartEndpoint, {
        credentials: 'include',
        mode: 'no-cors',
      });
    }
  };
}


export function addToCartSetLoading(loading) {
  return {
    type: types.ADD_TO_CART_SET_LOADING,
    loading,
  };
}

export function addToCartSetSuccess() {
  return {
    type: types.ADD_TO_CART_SET_SUCCESS,
  };
}


function addToCartRequest() {
  return {
    type: types.ADD_TO_CART_REQUEST,
  };
}

function addToCartResponse(data) {
  return {
    type: types.ADD_TO_CART_RESPONSE,
    data,
  };
}

export function addToCartHideNotification() {
  return {
    type: types.ADD_TO_CART_HIDE_NOTIFICATION,
  };
}

export function addToCart(hmac=null, price=0) {
  if (!hmac) {
    return;
  }

  // Build cart request into GET query string
  var cartEndpoint = `https://${config.FOXYCART_STORE_URL}/cart?`;
  Object.keys(hmac).forEach(p => cartEndpoint += `${p}=${encodeURIComponent(hmac[p][0])}||${hmac[p][1]}&`);
  cartEndpoint = cartEndpoint.slice(0, -1);

  return (dispatch, getState) => {
    dispatch(addToCartRequest());
    if(window.FC) {
      // Use native FoxyCart script to add product to cart
      window.FC.client.request(cartEndpoint)
      .done(json => {
        dispatch(addToCartResponse());
        dispatch(updateCart(json.items.length));
        window.FC.client.updateCart();

        // Facebook Pixel "add to cart" tracking
        if(window.fbq) {
          if(price > 0) {
            window.fbq('track', 'AddToCart', {
              value: price,
              currency: 'USD',
            });
          } else {
            window.fbq('track', 'AddToCart');
          }
        }

        setTimeout(() => {
          dispatch(addToCartHideNotification());
        }, 3000);
      });
    } else {
      // Fall back to fetch if Foxycart script isn't loaded
      console.log("Warning: FoxyCart script not loaded!");
      cartEndpoint += "&output=json&callback=?"
      return fetch(cartEndpoint, {
        credentials: 'include',
        mode: 'no-cors'
      })
      .then(response => {
        return response.text().then(function(text) {
          return text ? JSON.parse(text) : {}
        })
      })
      .then(json => {
        dispatch(addToCartResponse());
        dispatch(updateCart(json.items.length));
        setTimeout(() => {
          dispatch(addToCartHideNotification());
        }, 3000);
      })
      .catch(err => console.log(err));
    }
  }
}
